// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation_navigationLabel__3u9fS{display:flex;align-items:center}chevronIcon{margin:0 4px}", ""]);
// Exports
exports.locals = {
	"navigationLabel": "navigation_navigationLabel__3u9fS"
};
module.exports = exports;
